import React from 'react';
import FullPageCarousel from '../../../components/FullPageCarousel';

const SectionOne = () => {
  return (
    <section>
      <FullPageCarousel />
    </section>
  );
};

export default SectionOne;
